import { Component, Input, OnInit } from '@angular/core';
import { WorkProject, WorkTask } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-appointments',
  templateUrl: './ax-project-appointments.component.html',
  styleUrls: ['./ax-project-appointments.component.scss'],
})
export class AxProjectAppointmentsComponent implements OnInit {
  @Input() project: WorkProject;
  @Input() appointments: WorkTask[];
  @Input() isInternalView = false;
  public accordionStates: any = {};

  constructor() {
  }

  ngOnInit() {
  }
}
